import { Navigate, Route, Routes } from "react-router-dom";
import { Accessibility } from "./pages/Accessibility.tsx";
import { AppPage } from "./pages/AppPage.tsx";
import { Landing } from "./pages/Landing.tsx";
import { PaymentCancelled } from "./pages/PaymentCancelled.tsx";
import { PaymentSuccess } from "./pages/PaymentSuccess.tsx";
import { Privacy } from "./pages/Privacy.tsx";
import { Terms } from "./pages/Terms.tsx";
import { Docs } from "./pages/Docs.tsx";

export const App = () => (
  <Routes>
    <Route path="/" element={<Landing />} />
    <Route path="/app" element={<Navigate to="/events" replace />} />
    <Route path="/events" element={<AppPage />} />
    <Route path="/swipe" element={<AppPage />} />
    <Route path="/admin" element={<AppPage />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/accessibility" element={<Accessibility />} />
    <Route path="/payment-success" element={<PaymentSuccess />} />
    <Route path="/payment-cancelled" element={<PaymentCancelled />} />
    <Route path="/docs" element={<Docs />} />
  </Routes>
);
